import { Controller } from "@hotwired/stimulus"

// How long a search has been up, counting on from the value the server rendered
// so the number keeps moving on a page nobody reloads.
//
// Under a minute it counts seconds, because a search someone just opened should
// visibly be new; after that the seconds are noise.
export default class extends Controller {
    static targets = ["label"]
    static values = { seconds: Number }

    connect() {
        this.seconds = this.secondsValue
        this.render()
        this.timer = setInterval(() => {
            this.seconds += 1
            this.render()
        }, 1000)
    }

    disconnect() {
        clearInterval(this.timer)
    }

    render() {
        if (this.hasLabelTarget) this.labelTarget.textContent = this.format(this.seconds)
    }

    format(total) {
        if (total < 60) return `${total} s`

        const minutes = Math.floor(total / 60)
        if (minutes < 60) return `${minutes} min`

        const hours = Math.floor(minutes / 60)
        const rest = minutes % 60

        return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`
    }
}
